const parseSseBuffer = (buffer, onEvent) => {
  let rest = buffer;
  let boundary = rest.indexOf("\n\n");
  while (boundary !== -1) {
    const block = rest.slice(0, boundary);
    rest = rest.slice(boundary + 2);
    const dataLine = block.split("\n").find((line) => line.startsWith("data: "));
    if (dataLine) {
      try {
        onEvent(JSON.parse(dataLine.slice(6)));
      } catch (_) {
        // ignore malformed chunks
      }
    }
    boundary = rest.indexOf("\n\n");
  }
  return rest;
};

/**
 * Genera un informe organizacional con progreso en tiempo real (SSE) y devuelve el blob.
 */
export async function downloadOrgReportWithProgress({
  apiUrl,
  kind,
  body,
  onProgress,
  credentials = "include",
}) {
  const endpointByKind = {
    informe: "informeOrganizacional",
    guia: "guiaMetodologia",
    presentacion: "presentacionEjecutiva",
  };
  const endpoint = endpointByKind[kind];
  if (!endpoint) {
    throw new Error("Tipo de informe no válido.");
  }

  const timestamp = new Date().getTime();
  const response = await fetch(`${apiUrl}/informes/org/${endpoint}/stream?t=${timestamp}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials,
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let errorMsg = "Error al generar el informe organizacional.";
    try {
      const errJson = await response.json();
      if (errJson?.message) errorMsg = errJson.message;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  if (!response.body) {
    throw new Error("El servidor no devolvió progreso en tiempo real.");
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let jobId = null;
  let streamError = null;

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    buffer = parseSseBuffer(buffer, (event) => {
      if (event.type === "progress") {
        onProgress?.(event);
      } else if (event.type === "complete") {
        jobId = event.jobId;
      } else if (event.type === "error") {
        streamError = new Error(event.message || "Error al generar el informe organizacional.");
      }
    });
    if (streamError) throw streamError;
  }

  if (!jobId) {
    throw new Error("No se recibió confirmación de finalización del informe.");
  }

  const fileRes = await fetch(`${apiUrl}/informes/org/download/${jobId}?t=${timestamp}`, {
    credentials,
  });

  if (!fileRes.ok) {
    let errorMsg = "Error al descargar el informe generado.";
    try {
      const errJson = await fileRes.json();
      if (errJson?.message) errorMsg = errJson.message;
    } catch (_) {}
    throw new Error(errorMsg);
  }

  return {
    blob: await fileRes.blob(),
    contentDisposition: fileRes.headers.get("content-disposition"),
  };
}

export function triggerBlobDownload(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}

export function filenameFromContentDisposition(contentDisposition, fallback) {
  if (!contentDisposition) return fallback;
  const match = /filename\*?=(?:UTF-8''|")?([^";]+)/i.exec(contentDisposition);
  if (match?.[1]) return decodeURIComponent(match[1].replace(/"/g, ""));
  return fallback;
}
